import { useState } from "react";
import "./PreviousMatchReponseBlock.css";
import axios from "axios";
import { Link } from "react-router-dom";
import { getVip } from "../../handlers/dictionaryHandler.js";

const PreviousMatchResponseBlock = ({
  otherName,
  weeklyMatchesUsageLeft,
  matchId,
  otherId,
  onMatchRenewal,
  isOtherActive,
}) => {
  const [answerText, setAnswerText] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showSubscribeLink, setShowSubscribeLink] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const isAlreadySaidYes = true;

  const alertUser = (message) => {
    setAlertMessage(message);
    setShowSubscribeLink(false);
    setShowAlert(true);
  };

  const renewMatch = async () => {
    if (isOtherActive === false) {
      alertUser("המשתמש בהשהיית שימוש");
      return;
    }

    if (localStorage.getItem("VIP") !== "1") {
      setAlertMessage(
        "רוצה לתת להתאמה הזו עוד הזדמנות? 😊 הקפצת התאמות זמינה למנויים",
      );
      setShowSubscribeLink(true);
      setShowAlert(true);
      return;
    }

    if (answerText.length === 0) {
      alertUser("רק צריך להשאיר כמה מילים לצד השני ואפשר לנסות שוב 😊");
      return;
    }

    setIsSubmitting(true);
    try {
      const config = {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      };
      await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + `/prevMatches_proc`,
        {
          matchId,
          otherId,
          msgForOtherSide: answerText,
        },
        config,
      );
      await onMatchRenewal(matchId);
      setIsSuccess(true);
      const message = `💜 ההתאמה הוקפצה בהצלחה!
סימנת שתרצה/י להכיר, ושלחנו ל${otherName} הודעה להגיב.
עכשיו מחכים לתשובה. אפשר לעקוב אחרי ההתאמה בלשונית "התאמות פעילות".`;
      setAlertMessage(message);
      setShowAlert(true);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        alertUser("כבר הקפצת את ההתאמה הזו השבוע 😊");
      } else {
        alertUser("לא הצלחנו להקפיץ את ההתאמה, נא לנסות שוב");
      }
    }
    setIsSubmitting(false);
  };

  const isQuotaExhausted = weeklyMatchesUsageLeft <= 0;

  return (
    <div className="response-container">
      <div className="faceline">
        <div>
          {!isSuccess && (
            <>
              <div id="btnSubmit" style={{ fontSize: 16, fontWeight: "bold" }}>
                💜 רוצה להקפיץ את ההתאמה?
              </div>

              {isQuotaExhausted ? (
                <span style={{ color: "var(--grey-color)" }}>
                  ניצלת השבוע את כל ההקפצות האפשריות.
                </span>
              ) : (
                <div id="btnSubmit" style={{ fontSize: 14, margin: "6px 0" }}>
                  <p>
                    הקפצה מסמנת שתרצה/י להכיר ומעבירה את ההתאמה למסך "התאמות
                    פעילות".
                    <br />
                    דאבל ישלח ל{otherName} הודעה עם בקשה להגיב 💌
                  </p>
                  <p>
                    {weeklyMatchesUsageLeft === 1
                      ? "נותרה לך הקפצה אחת השבוע."
                      : `נותרו לך ${weeklyMatchesUsageLeft} הקפצות השבוע.`}
                  </p>
                </div>
              )}

              <div className="freetext-container">
                <textarea
                  style={{ height: "40px" }}
                  className="freetext"
                  rows="3"
                  maxLength="100"
                  disabled={isQuotaExhausted || isSubmitting}
                  placeholder={
                    isQuotaExhausted
                      ? "אפשר להקפיץ שוב בשבוע הבא..."
                      : `מה בא לך לכתוב ל${otherName}?`
                  }
                  value={answerText}
                  onChange={(e) => setAnswerText(e.target.value)}
                />
              </div>

              <div
                id="btnSubmit"
                onClick={() => {
                  if (!isSubmitting && !isQuotaExhausted) {
                    renewMatch();
                  }
                }}
                style={{
                  backgroundColor:
                    answerText.trim().length > 0 && !isQuotaExhausted
                      ? "var(--btn-color)"
                      : "var(--grey-color)",
                  margin: "14px auto 0",
                  padding: 8,
                  borderWidth: 0,
                  textAlign: "center",
                  fontSize: 18,
                  borderRadius: 10,
                  fontFamily: "Heebo-VariableFon",
                  color: "var(--btnText-color)",
                  cursor:
                    isSubmitting || isQuotaExhausted ? "default" : "pointer",
                  opacity: isSubmitting ? 0.6 : 1,
                  pointerEvents: isSubmitting ? "none" : "auto",
                  userSelect: isSubmitting ? "none" : "auto",
                }}
              >
                {isSubmitting ? "שולח..." : "💜 הקפצה להתאמות פעילות"}
              </div>
            </>
          )}

          {showAlert && (
            <div className="error-message">
              <h5 style={{ whiteSpace: "pre-line" }}>{alertMessage}</h5>

              {showSubscribeLink && (
                <div className="lbl_grey">
                  <Link to="/Subscribe">לרכישת מנוי</Link> במחיר של כוס קפה
                  חודשית
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PreviousMatchResponseBlock;
